import { CarbonIconType } from '@carbon/icons-react';
import { RouteComponentProps } from '@reach/router';
import React from 'react';

import { PrivateRouteLayoutProps } from '#coreComponents/PrivateRoute/PrivateRoute';
import dataplusConfig from '../features/dataplus/config';
import dataplusLatamConfig from '../features/dataplusLatam/config';
import exploreConfig from '../features/explore/config';
import wurReporterInterimConfig from '../features/wurReporterInterim/config';
import reputationConfig from '../features/reputation/config';
import sdgImpactConfig from '../features/sdgImpact/config';
import resourcesConfig from '../features/resources/config';

export interface PageConfig {
  noChildren?: boolean;
  isDevProduct?: boolean;
  isWurReporterInterim?: boolean;
  topbar: {
    title: string;
    titleAcronym: string;
    rank: string;
    filter: {
      hasPeerSelector: boolean;
      hasQueryBuilder: boolean;
    };
    downloadUrls?: {
      xlsx?: string;
      csv?: string;
      methodology?: string;
    };
  };
  useNonYearPermissions: boolean;
}

export interface Page {
  name: string;
  path: string;
  component: React.FC<{ pageConfig: PageConfig }>;
  upsellComponent?: React.FC<{}>;
  layout?: React.FC<PrivateRouteLayoutProps>;
  pageConfig: DeepPartial<PageConfig>;
  hiddenPage?: boolean;
  featureFlagId?: string;
}

export interface Product {
  layout?: React.FC<PrivateRouteLayoutProps | {}>;
  name: string;
  authKey?: string;
  description: string;
  path: string;
  icon: CarbonIconType;
  color: string;
  pages: Page[];
  pageQuery?: React.FC<RouteComponentProps>;
  productConfig: DeepPartial<PageConfig>;
  usesLegacyPermissions?: boolean;
  featureFlagId?: string;
  disabledFeatureComponent?: React.FC<{}>;
}

export default [
  dataplusConfig,
  dataplusLatamConfig,
  exploreConfig,
  wurReporterInterimConfig,
  reputationConfig,
  sdgImpactConfig,
  resourcesConfig,
];
